export default "__VITE_ASSET__ps28n84L__"